
import { PasswordStrengthService } from "../../services/common/password/password.service";
import { PasswordStrengthResult } from '../../../model/common/password';
import { Constant } from "../../../model/common/constant";

let template = require("./password.html");


export class PasswordComponentController implements ng.IComponentController {

    public password: string;
    public passwordStatus: PasswordStrengthResult = new PasswordStrengthResult();
    public passwordStrengthSrv: PasswordStrengthService;
    public userPasswordForm: ng.IFormController;

    public confirmPassword: string;
    public FormSubmitted: boolean = false;
    public PasswordFollowing: boolean = false;
    public static $inject: Array<string> = ["PasswordStrengthService", "$scope"];
    constructor(passwordStrengthSrv: PasswordStrengthService, public $scope: ng.IScope) {
        this.passwordStrengthSrv = passwordStrengthSrv;
        this.$scope = $scope;
    }

    onChangePassword() {
        this.FormSubmitted = false;
        this.passwordStatus = this.passwordStrengthSrv.Validate(this.password, this.confirmPassword);
        if ((this.passwordStatus.UpperCasePatternValidated ? 1 : 0) + (this.passwordStatus.LowerCasePatternValidated ? 1 : 0) + (this.passwordStatus.NumberCharacterPatternValidated ? 1 : 0) + (this.passwordStatus.SpecialCharacterPatternValidated ? 1 : 0) >= 3) {
            this.PasswordFollowing = true;
        }
        else {
            this.PasswordFollowing = false;
        }
    }


    $onInit() {
        this.passwordStatus = new PasswordStrengthResult();
        this.password = "";
        this.confirmPassword = "";    
        this.$scope.$on(Constant.Event.ChangePasswordFormSubmit, () => {
            this.FormSubmitted = true;
        });
    }
}



export let passwordTextBoxComponent: ng.IComponentOptions = {
    transclude: true,
    template: template.default,
    controllerAs: Constant.CtrlAs,
    controller: PasswordComponentController,
    bindings: {
        password: Constant.Binding.TWOWAY,
        passwordStatus: Constant.Binding.TWOWAY
    }
};